import { __extends } from "tslib";
var Information = (function (_super) {
    __extends(Information, _super);
    function Information(message) {
        var _this = _super.call(this, message) || this;
        _this.isInformation = true;
        _this.constructor = Information;
        _this.__proto__ = Information.prototype;
        _this.name = 'Information';
        return _this;
    }
    return Information;
}(Error));
export { Information };
var Warning = (function (_super) {
    __extends(Warning, _super);
    function Warning(message) {
        var _this = _super.call(this, message) || this;
        _this.isWarning = true;
        _this.constructor = Warning;
        _this.__proto__ = Warning.prototype;
        _this.name = 'Warning';
        return _this;
    }
    return Warning;
}(Error));
export { Warning };
var Status404Error = (function (_super) {
    __extends(Status404Error, _super);
    function Status404Error() {
        var _this = _super.call(this, '404') || this;
        _this.constructor = Status404Error;
        _this.__proto__ = Status404Error.prototype;
        _this.name = 'Status404Error';
        return _this;
    }
    return Status404Error;
}(Information));
export { Status404Error };
